import * as S from './Header.styled';

const Header = () => (
  <S.Container>
    <div>
      <S.Title>📚 More resources</S.Title>
      <S.Text>Get acquainted with useful information.</S.Text>
    </div>
  </S.Container>
);

export default Header;
